import Phaser from 'phaser';
import ItemSystem from './modules/ItemSystem.js';
import MenuUI from './modules/MenuUI.js';
import EquipmentMenuUI from './modules/EquipmentMenuUI.js';
import MenuController from './modules/MenuController.js';
import ItemMenuHandler from './modules/ItemMenuHandler.js';
import EquipmentMenuHandler from './modules/EquipmentMenuHandler.js';
import GameStateStore from './modules/GameStateStore.js';

export default class MenuScene extends Phaser.Scene {
    constructor() {
        super('MenuScene');
    }
    
    init(data) {
        // 初始化菜单状态
        this.playerData = null;
        this.optionTexts = []; // 用于子菜单的文本存储
        // 保存之前场景的 key，以便关闭时恢复
        this.previousSceneKey = data?.previousSceneKey || 'WorldScene';
    }
    
    create() {
        // 确保菜单场景显示在最上层
        this.scene.bringToTop('MenuScene');
        
        // 加载玩家数据
        this.playerData = GameStateStore.getPlayer();
        
        // 创建菜单UI模块
        this.menuUI = new MenuUI(this);
        this.menuUI.createBackground();
        this.menuUI.createContainers();
        
        // 创建装备菜单UI模块
        this.equipmentMenuUI = new EquipmentMenuUI(this);
        this.equipmentMenuUI.setContainers(
            this.menuUI.elements.menuList,
            this.menuUI.elements.infoPanel
        );
        
        // 创建菜单处理器
        this.itemHandler = new ItemMenuHandler(this, this.menuUI);
        this.equipmentHandler = new EquipmentMenuHandler(this, this.menuUI, this.equipmentMenuUI);
        
        // 创建菜单控制器
        this.menuController = new MenuController(
            this,
            this.menuUI,
            this.equipmentMenuUI,
            this.itemHandler,
            this.equipmentHandler
        );
        
        // 初始化菜单数据
        this.menuController.initMenuData(this.playerData);
        
        // 设置输入控制
        this.menuController.setupControls();
        
        // 显示主菜单
        this.menuController.showMenu('main', this.playerData);
    }
    
    /**
     * 关闭菜单
     */
    closeMenu() {
        if (this.menuController) {
            this.menuController.destroyControls();
        }
        const previousSceneKey = this.previousSceneKey || 'WorldScene';
        this.scene.stop();
        this.scene.resume(previousSceneKey, {
            from: 'MenuScene',
            player: GameStateStore.getPlayer() || this.playerData
        });
    }

    shutdown() {
        if (this.menuController) {
            this.menuController.destroyControls();
        }
    }
}
